import React, { useEffect, useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';

export default function TrmBriefRequestPicker({ organizationId, onBack, onSelect }: { organizationId: string; onBack: () => void; onSelect: (requestId: string) => void }) {
    const [requests, setRequests] = useState<Array<{ id: string; requestReference: string; status: string }>>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    useEffect(() => {
        let cancelled = false;
        httpsCallable(getFunctions(undefined, 'us-central1'), 'manageTrmBrief')({ action: 'list', organizationId })
            .then(response => { if (!cancelled) setRequests((response.data as any).requests || []); })
            .catch((failure: any) => { if (!cancelled) setError(failure.message || 'Travel briefs failed loading.'); })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, [organizationId]);
    return <div className="mx-auto max-w-4xl space-y-5 p-6"><button onClick={onBack} className="text-sm font-bold text-blue-700">← Travel Risk Management</button>
        <h1 className="text-2xl font-black">Comprehensive Travel Security Briefs</h1>
        <p className="text-sm text-slate-600">Open an accepted TRM-01 request.</p>
        {error && <p role="alert" className="rounded-lg bg-red-50 p-4 text-red-700">{error}</p>}
        {loading ? <p>Loading briefs…</p> : requests.length ? <div className="space-y-3">{requests.map(item =>
            <button key={item.id} onClick={() => onSelect(item.id)} className="flex w-full justify-between rounded-xl border bg-white p-5 text-left shadow-sm">
                <span className="font-bold">{item.requestReference}</span><span className="text-sm capitalize">{item.status.replaceAll('_', ' ')}</span></button>)}</div>
            : <p className="rounded-lg bg-slate-100 p-5 text-slate-600">No accepted TRM-01 requests.</p>}</div>;
}
